import { RouteItem } from '@eastcoal/router/types/route'

import { ACCOUNT_STATEMENT_UUID } from './constants/uuid'

export const accountStatementRoute: RouteItem = {
  title: '账户明细表',
  uuid: ACCOUNT_STATEMENT_UUID,
  path: '/accountStatement',
  Component: () => import('./index')
}
